export const Warning = () => {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.69066 1.74455L1.20522 12.6799C1.07151 12.9138 1.00075 13.179 1.00001 13.449C0.999257 13.7191 1.06854 13.9847 1.20095 14.2193C1.33337 14.4539 1.52431 14.6495 1.75477 14.7864C1.98523 14.9234 2.24718 14.997 2.51456 15H15.4854C15.7528 14.997 16.0148 14.9234 16.2452 14.7864C16.4757 14.6495 16.6666 14.4539 16.799 14.2193C16.9315 13.9847 17.0007 13.7191 17 13.449C16.9992 13.179 16.9285 12.9138 16.7948 12.6799L10.3093 1.74455C10.1728 1.51726 9.98064 1.32935 9.7513 1.19893C9.52195 1.06851 9.2632 1 9 1C8.7368 1 8.47805 1.06851 8.2487 1.19893C8.01936 1.32935 7.82716 1.51726 7.69066 1.74455V1.74455Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 5L9 9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="12" r="1" fill="currentColor" />
    </svg>
  )
}
